import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
  LineChart, Line,
} from "recharts";

const kfmt = (v) => `${Math.round((v || 0) / 1000)}k`;
const AXIS = { fontSize: 11, fill: "#94A3B8" };

function TT({ active, payload, label, suffix = " €" }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="rounded-lg bg-slate-800 text-white px-3 py-2 text-xs shadow-lg border border-slate-700">
      <p className="font-semibold mb-1">Anno {label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="font-mono-fin flex items-center gap-2">
          <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: p.color }} />
          {p.name}: {Number(p.value).toLocaleString("it-IT")}{suffix}
        </p>
      ))}
    </div>
  );
}

export function ProjectionCharts({ projections, t, lang }) {
  if (!Array.isArray(projections) || !projections.length) return null;
  const data = projections.map((r) => ({ ...r, cum_fcf: 0 }));
  let cum = 0;
  data.forEach((r) => { cum += r.fcf; r.cum_fcf = cum; });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-testid="bp-projection-charts">
      <div className="rounded-xl border border-slate-800 bg-slate-900 p-5 print-break">
        <h3 className="font-heading text-sm font-semibold text-white mb-4">
          {lang === "it" ? "Ricavi · EBITDA · Utile" : "Revenue · EBITDA · Net income"}
        </h3>
        <div style={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#1E293B" />
              <XAxis dataKey="year" tick={AXIS} axisLine={false} tickLine={false} />
              <YAxis tick={AXIS} axisLine={false} tickLine={false} tickFormatter={kfmt} width={40} />
              <Tooltip content={<TT />} cursor={{ fill: "#1E293B" }} />
              <Legend wrapperStyle={{ fontSize: 11, color: "#CBD5E1" }} iconType="circle" />
              <Bar dataKey="revenue" name={lang === "it" ? "Ricavi" : "Revenue"} fill="#2563EB" radius={[4, 4, 0, 0]} />
              <Bar dataKey="ebitda" name="EBITDA" fill="#22D3EE" radius={[4, 4, 0, 0]} />
              <Bar dataKey="net_income" name={lang === "it" ? "Utile" : "Net"} fill="#10B981" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="rounded-xl border border-slate-800 bg-slate-900 p-5 print-break">
        <h3 className="font-heading text-sm font-semibold text-white mb-4">
          {lang === "it" ? "Free Cash Flow e FCF cumulato" : "Free Cash Flow & cumulative"}
        </h3>
        <div style={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <LineChart data={data} margin={{ top: 8, right: 16, left: 8, bottom: 4 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#1E293B" />
              <XAxis dataKey="year" tick={AXIS} axisLine={false} tickLine={false} />
              <YAxis tick={AXIS} axisLine={false} tickLine={false} tickFormatter={kfmt} width={44} />
              <Tooltip content={<TT />} />
              <Legend wrapperStyle={{ fontSize: 11, color: "#CBD5E1" }} iconType="circle" />
              <Line type="monotone" dataKey="fcf" name="FCF" stroke="#22D3EE" strokeWidth={2.5} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="cum_fcf" name={lang === "it" ? "FCF cumulato" : "Cumulative FCF"} stroke="#F59E0B" strokeWidth={2.5} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
